import {
  fetchGetDesktopOnboardings,
  TGetDesktopOnboardingsResponse_1,
} from '../../repositories/mobile-app-onboarding/v1/get-desktop-onboardings';
import { withTypeSafeApiResult } from '../../utils/typesafe-result';

/* istanbul ignore next */
export const fetchGetDesktopOnboardingsSafe =
  withTypeSafeApiResult<TGetDesktopOnboardingsResponse_1>(fetchGetDesktopOnboardings);
